import { KineticOrganization } from '@kinetic-ui/data-layer';
import { sessionTenantManager, useUserKineticPreference } from '@kinetic-ui/shared';
import { useEffect } from 'react';
import { SelectedOrgPreference } from './AppPreload';
import { useAuth } from 'react-oidc-context';

export const useInitializeTenant = ({
  allOrganizations,
  defaultOrgPreference: { value: preference, loading: defaultLoading },
}: {
  allOrganizations: KineticOrganization[] | undefined;
  defaultOrgPreference: ReturnType<typeof useUserKineticPreference<SelectedOrgPreference>>;
}) => {
  const auth = useAuth();
  const currentOrganization = sessionTenantManager.getCurrentOrganization();
  const defaultOrg = preference?.defaultOrganization;
  useEffect(() => {
    // wait till we load the user orgs.
    if (!allOrganizations || currentOrganization || defaultLoading || !auth.isAuthenticated) {
      return;
    }
    if (allOrganizations.length === 0) {
      throw new Error('User does not belong to any organizations!');
    }

    function verifyAndSet(org: string) {
      if (allOrganizations) {
        // verify the org is in all orgs.
        if (!allOrganizations.find((all) => all.id === org)) {
          // console.warn(
          //   'detected the default org is not in the users list default to the first item'
          // );
          sessionTenantManager.setCurrentOrganization(allOrganizations[0].id);
        } else {
          sessionTenantManager.setCurrentOrganization(org);
        }
      }
    }
    const sessionOrg = sessionTenantManager.getCurrentOrganization();

    if (sessionOrg) {
      return;
    }
    if (!defaultOrg) {
      sessionTenantManager.setCurrentOrganization(allOrganizations[0].id);
    } else {
      verifyAndSet(defaultOrg);
    }
  }, [
    auth.isAuthenticated,
    auth?.user?.access_token,
    currentOrganization,
    defaultLoading,
    defaultOrg,
    allOrganizations,
  ]);
};
